/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.Notes";
        class ComponentNotes extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = null;
                // UI Components
                this._suppressDisplay = false;
                this._loader = null;
                this._noRecords = null;
                this._listRoot = null;
                this._colours = {};
                this._counter = 0;
                // Create Note Modal
                this._createModalSelectHolder = null;
                this._createModalInput = null;
                this._createModalOK = null;
                this._createModalLoader = null;
                this._createCallback = null;
                this._currentModalSession = null;
                this._createModalOptionInput = null;
                this._createModalNoteTypeOptions = null;
                // Data state
                this._displayTypes = [];
                this._createTypes = [];
                this._currentDocId = null;
                this._noteList = [];
                this._storeHtml = (htmlData) => {
                    this._log.info("NotesComponent._storeHtml()");
                    ComponentNotes.Html = htmlData;
                    if (ComponentNotes.ModalHtml != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._storeModalHtml = (htmlData) => {
                    this._log.info("NotesComponent._storeModalHtml()");
                    ComponentNotes.ModalHtml = htmlData;
                    if (ComponentNotes.Html != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this.showNotesForDocument = (doc) => {
                    this._log.info("NotesComponent.showNotesForDocument()");
                    this._currentDocId = doc.ItemNum;
                    if (!this._componentReady) {
                        this._displayPending = 'service';
                        return;
                    }
                    else {
                        this._loadNotes();
                    }
                };
                this.showNotesForDocumentId = (doc) => {
                    this._log.info("NotesComponent.showNotesForDocumentId()");
                    this._currentDocId = doc;
                    if (!this._componentReady) {
                        this._displayPending = 'service';
                        return;
                    }
                    else {
                        this._loadNotes();
                    }
                };
                this.showNotes = (notes) => {
                    this._log.info("NotesComponent.showNotes()");
                    if (notes)
                        this._noteList = notes;
                    else
                        this._noteList = [];
                    if (!this._componentReady) {
                        this._displayPending = 'recordList';
                        return;
                    }
                    else {
                        this._displayNotes();
                    }
                };
                this._loadNotes = () => {
                    this._log.info("NotesComponent._loadNotes()");
                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetNotes/${this._currentDocId}`, this._receiveNotes, this._errorCallback, this._failCallback);
                };
                this._receiveNotes = (response) => {
                    this._log.info("NotesComponent._receiveNotes()");
                    if (response.hasOwnProperty('Notes') && response.Notes) {
                        this._noteList = response.Notes;
                    }
                    else {
                        this._noteList = [];
                    }
                    this._displayNotes();
                };
                this._displayNotes = () => {
                    this._log.info("NotesComponent._displayNotes()");
                    if (this._suppressDisplay)
                        return;
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.hideElement(this._listRoot);
                    this._listRoot.innerHTML = "";
                    let displayed = false;
                    let fragment = document.createDocumentFragment();
                    this._noteList.forEach(note => {
                        if ((this._displayTypes.indexOf('*') > -1) || (this._displayTypes.indexOf(note.Type) > -1)) {
                            this._counter++;
                            let counter = this._counter.toString();
                            let noteEntry = document.createElement('li');
                            fragment.appendChild(noteEntry);
                            let outerDiv = document.createElement('div');
                            noteEntry.appendChild(outerDiv);
                            outerDiv.classList.add('note-box');
                            outerDiv.setAttribute('data-id', counter);
                            if (note.Type in this._colours) {
                                let colour = this._colours[note.Type];
                                let contrast = this._core.Helper.contrastText(colour);
                                outerDiv.style.backgroundColor = colour;
                                outerDiv.style.color = contrast;
                                outerDiv.style.borderColor = contrast;
                            }
                            outerDiv.addEventListener('click', this._noteClicked);
                            let headingDiv = document.createElement('div');
                            outerDiv.appendChild(headingDiv);
                            headingDiv.classList.add('note-heading');
                            let innerHeadingDiv = document.createElement('div');
                            innerHeadingDiv.classList.add('note-title');
                            innerHeadingDiv.appendChild(document.createTextNode(note.Title + ":"));
                            headingDiv.appendChild(innerHeadingDiv);
                            let userDiv = document.createElement('div');
                            headingDiv.appendChild(userDiv);
                            userDiv.classList.add('note-info');
                            let userSpan = document.createElement('span');
                            userDiv.appendChild(userSpan);
                            userSpan.appendChild(document.createTextNode(note.User));
                            let dateSpan = document.createElement('span');
                            userDiv.appendChild(dateSpan);
                            dateSpan.classList.add('pull-right');
                            if (note.Date)
                                dateSpan.appendChild(document.createTextNode(this._core.OBHelper.formatDate(note.Date)));
                            let contentDiv = document.createElement('div');
                            outerDiv.appendChild(contentDiv);
                            contentDiv.id = `noteContent_${counter}`;
                            contentDiv.classList.add('note-content', WPTNamespace.HIDDEN_CLASS);
                            contentDiv.appendChild(document.createTextNode(note.Text));
                            displayed = true;
                        }
                    });
                    // Show no records if we've found nothing to show
                    if (!displayed)
                        this._core.Functions.showElement(this._noRecords);
                    else {
                        this._listRoot.appendChild(fragment);
                        this._core.Functions.showElement(this._listRoot);
                    }
                };
                this._noteClicked = (event) => {
                    this._log.info("NotesComponent._noteClicked()");
                    let clickedItem = event.currentTarget;
                    let tag = clickedItem.getAttribute('data-id');
                    let contentDiv = this._listRoot.querySelector(`#noteContent_${tag}`);
                    if (contentDiv) {
                        contentDiv.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                    }
                };
                this.clearDisplay = () => {
                    this._log.info("NotesComponent.clearDisplay()");
                    // Don't risk firing against undefined setup
                    if (this._componentReady) {
                        this._currentDocId = null;
                        this._noteList = [];
                        this._listRoot.innerHTML = '';
                    }
                };
                this.createNote = (noteType, noteContent) => {
                    this._log.info("NotesComponent.createNote()");
                    let request = { Name: noteType, Content: noteContent };
                    this._core.Loader.genericServiceCallWithData(`/Documents.svc/rest/AddNote/${this._currentDocId}`, JSON.stringify(request), this._noteCreated, {}, this._createNoteError, this._createNoteFailure);
                };
                this.createNoteInteractive = (docId = 0, callback = null) => {
                    this._log.info("NotesComponent.createNoteInteractive()");
                    if (this._suppressDisplay && (docId != 0))
                        this._currentDocId = docId;
                    if (callback != null)
                        this._createCallback = callback;
                    // Set up modal
                    let modalSession = 'add-note-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentModalSession = modalSession;
                        modal.DIV.innerHTML = ComponentNotes.ModalHtml;
                        this._createModalSelectHolder = modal.DIV.querySelector('#noteAddTypeSelectHolder');
                        this._createModalInput = modal.DIV.querySelector('#noteAddContentTextbox');
                        this._createModalOK = modal.DIV.querySelector('#noteAddOK');
                        this._createModalLoader = modal.DIV.querySelector('#noteAddLoader');
                        this._core.Helper.prepareHourglassIcon(this._createModalLoader);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#noteAddDialogHeading'), 'STR_WPT_CREATE_NOTE');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#noteAddCancelLabel'), 'STR_WPT_CANCEL');
                        this._core.Helper.setElementTranslation(this._createModalOK.querySelector('#noteAddOKLabel'), 'STR_WPT_CREATE');
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#noteAddTypeLabel'), 'STR_WPT_NOTE_TYPE');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#noteAddContentLabel'), 'STR_WPT_NOTE_CONTENT');
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#noteAddContentTextbox'), 'placeholder', 'STR_WPT_NOTE_CONTENT');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#noteAddProcessing'), 'STR_WPT_PROCESSING');
                        this._createModalInput.addEventListener('input', this._enableDisableCreateOK);
                        this._createModalOK.addEventListener('click', this._createOKClicked);
                        this._createModalNoteTypeOptions = {
                            Items: []
                        };
                        let optionConfig = {
                            Options: this._createModalNoteTypeOptions,
                            ValueMustExist: true,
                            AllowEmptyValue: false,
                            ChangeCallback: this._enableDisableCreateOK
                        };
                        this._createModalOptionInput = new Widgets.ComponentOptionInput(this._core, this._createModalSelectHolder, this._parent, optionConfig);
                        this._createModalOptionInput.present();
                        this._createModalOptionInput.Input.id = "noteAddTypeSelect";
                    }
                    else {
                        console.error("unable to show add note modal, modal placeholder is already used");
                    }
                    this._core.OBHelper.LoadNoteTypes(this._finaliseCreateDialog);
                };
                this._finaliseCreateDialog = () => {
                    this._log.info("NotesComponent._finaliseCreateDialog()");
                    this._createModalNoteTypeOptions = {
                        Items: []
                    };
                    this._core.OBHelper.NoteTypeNames.forEach(ntName => {
                        let noteTypeOption = {
                            Id: ntName,
                            DisplayName: ntName
                        };
                        this._createModalNoteTypeOptions.Items.push(noteTypeOption);
                    });
                    this._createModalOptionInput.Options = this._createModalNoteTypeOptions;
                    this._createModalOptionInput.Input.value = this._createModalNoteTypeOptions.Items[0].DisplayName;
                    this._core.showModal(this._currentModalSession);
                };
                this._enableDisableCreateOK = (event) => {
                    this._log.info("NotesComponent._enableDisableCreateOK()");
                    if ((this._createModalInput.value != "") && (this._createModalOptionInput.Input.value != ""))
                        this._createModalOK.disabled = false;
                    else
                        this._createModalOK.disabled = true;
                };
                this._createOKClicked = (event) => {
                    this._log.info("NotesComponent._createOKClicked()");
                    this._core.Functions.showElement(this._createModalLoader);
                    this.createNote(this._createModalOptionInput.Input.value, this._createModalInput.value);
                };
                this._noteCreated = (response) => {
                    this._log.info("NotesComponent._noteCreated()");
                    this._core.hideModal(this._currentModalSession);
                    this._currentModalSession = null;
                    if (this._createCallback != null) {
                        this._createCallback();
                        this._createCallback = null;
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this._parent, WPTNamespace.Navigation.LayoutActivationType.NOTE_CREATED);
                    navEvent.ActivationID = this._currentDocId;
                    navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._loadNotes();
                };
                this._createNoteError = (url, status, statusText) => {
                    this._log.info("NotesComponent._createNoteError()");
                    this._core.Functions.hideElement(this._createModalLoader);
                    if (this._errorCallback)
                        this._errorCallback(url, status, statusText);
                };
                this._createNoteFailure = (json) => {
                    this._log.info("NotesComponent._createNoteFailure()");
                    this._core.Functions.hideElement(this._createModalLoader);
                    if (this._failCallback)
                        this._failCallback(json);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NotesComponent::constructor");
                // Configuration moved from base class so we can type it correctly
                this._config = config;
                if (config.hasOwnProperty('Colours') && (config.Colours))
                    this._colours = config.Colours;
                if (config.hasOwnProperty('DisplayTypes') && (config.DisplayTypes != null))
                    this._displayTypes = config.DisplayTypes;
                else
                    this._displayTypes = ['*'];
                if (config.hasOwnProperty('CreateTypes') && (config.CreateTypes != null))
                    this._createTypes = config.CreateTypes;
                else
                    this._createTypes = ['*'];
                if (config.hasOwnProperty('SuppressDisplay') && (config.SuppressDisplay))
                    this._suppressDisplay = config.SuppressDisplay;
                // Need to prod the OBHelper to get the note types loaded
                this._core.OBHelper.LoadNoteTypes();
                if (ComponentNotes.Html != null && ComponentNotes.ModalHtml != null) {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
                else {
                    if (ComponentNotes.Html == null) {
                        core.Loader.getVersionedHTML('widgets/components/notes.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (ComponentNotes.ModalHtml == null) {
                        core.Loader.getVersionedHTML('widgets/components/notes-modal.html', this._storeModalHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
            _present() {
                this._log.info("NotesComponent._present()");
                // Don't present if we are not displaying
                if (this._suppressDisplay) {
                    this._componentReady = true;
                    return;
                }
                this._container.innerHTML = ComponentNotes.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#noteComponentNoRecords');
                this._listRoot = this._container.querySelector('#noteComponentKeywordList');
                this._core.Helper.prepareHourglassIcon(this._loader);
                // Several translations required
                this._core.Helper.setElementTranslation(this._container.querySelector('#noteComponentLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#noteComponentNoRecordsLabel'), 'STR_WPT_NO_NOTES_ATTACHED');
                this._componentReady = true;
                if (this._displayPending == 'service')
                    this._loadNotes();
                else if (this._displayPending == 'recordList')
                    this._displayNotes();
            }
        }
        ComponentNotes.Html = null;
        ComponentNotes.ModalHtml = null;
        Widgets.ComponentNotes = ComponentNotes;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
